module.exports = __webpack_public_path__ + "static/media/redirects-guide.dc0c6ccf.png";